import { BOOKING_TIMEZONE } from '../types';

/**
 * Returns today's date string in Riyadh timezone (YYYY-MM-DD).
 */
export function todayInRiyadh(): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: BOOKING_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

/**
 * Returns true if the given ISO date string is in the past (Riyadh time).
 */
export function isPastDateInRiyadh(isoDate: string): boolean {
  return isoDate < todayInRiyadh();
}

/**
 * Converts a Date object to an ISO date string (YYYY-MM-DD).
 */
export function formatDateToIso(date: Date): string {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}
